import { useRef } from 'react'

import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constants/icon'

interface ILoaderIconProps {
  width?: number
  height?: number
  className?: string
  onClick?: (event: any) => void
}

export const LoaderIcon = ({
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  className = '',
  onClick,
}: ILoaderIconProps) => {
  const unicID = useRef('_' + Math.random().toString(36).substr(2, 9)).current

  return (
    <svg
      data-testid={'loaderIcon'}
      className={className}
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 38 38"
      fill="none"
    >
      <defs>
        <linearGradient
          data-testid="loaderIconGradient"
          id={unicID}
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
          <stop offset="50%" stopColor="currentColor" stopOpacity="0.8" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
        </linearGradient>
      </defs>

      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <circle
          data-testid="loaderIconCircle"
          cx="18"
          cy="18"
          r="16"
          stroke={`url(#${unicID})`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="100 20"
        >
          <animateTransform
            data-testid="loaderIconAnimation"
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="0.9s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </svg>
  )
}
